import { render, staticRenderFns } from "./BlogSettings.vue?vue&type=template&id=72bcf83a"
import script from "./BlogSettings.vue?vue&type=script&lang=js"
export * from "./BlogSettings.vue?vue&type=script&lang=js"
import style0 from "./BlogSettings.vue?vue&type=style&index=0&id=72bcf83a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports